import { render, staticRenderFns } from "./lumbung_pangan.vue?vue&type=template&id=0a455de0&"
import script from "./lumbung_pangan.vue?vue&type=script&lang=js&"
export * from "./lumbung_pangan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports